import axios, { AxiosResponse } from "axios";
import { ethers } from "ethers";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import LicenseSoulboundNFTArtifact from "../artifacts/contracts/LicenseSoulboundNFT.sol/LicenseSoulboundNFT.json";
import License from "../common/models/License";
import { NavBar } from "../components/NavBar";
import { Table } from "../components/Table/Table";
import { useAuth } from "../hooks/useAuth";
import { getSelectedProvider } from "../utils";

interface RevokeLicenseProps {
  theme: string;
  toggleTheme: any;
}

const RevokeLicensesPageContainer = styled.div`
  background: #000D30;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

const RevokeLicensePage: React.FC<RevokeLicenseProps> = ({
  theme,
  toggleTheme,
}) => {
  const [pendingRevokalLicenses, setPendingRevokalLicenses] =
    useState<License[]>();

  const auth = useAuth();

  useEffect(() => {
    fetchRevokedLicenses();
  }, []);

  const fetchRevokedLicenses = async () => {
    const response = await axios.get(
      process.env.REACT_APP_BACKEND_URL + "/get_pending_revoke_licenses"
    );
    if (response) {
      const licenses = response.data.pending_revoke_licenses as Array<License>;
      setPendingRevokalLicenses(licenses);
    }
  };

  const [searchQuery, setSearchQuery] = useState("");

  const columns = useMemo(
    () => [
      {
        Header: "NFT Address",
        accessor: "address",
      },

      {
        Header: "NFT License ID",
        accessor: "id",
      },

      {
        Header: "Wallet Owner",
        accessor: "owner",
      },
      {
        Header: "Reason",
        accessor: "revoke_comments",
      },
      {
        Header: "Song Id",
        accessor: "song_id",
      },
    ],
    []
  );

  const onApproveClick = async (license: License) => {
    if (window.ethereum) {
      const selectedProvider = getSelectedProvider();
      const provider = new ethers.providers.Web3Provider(selectedProvider);
      const licenseContract = new ethers.Contract(
        license.address,
        LicenseSoulboundNFTArtifact.abi,
        provider.getSigner()
      );
      const deployedLicenseContract = new ethers.Contract(
        licenseContract.address,
        LicenseSoulboundNFTArtifact.abi,
        provider.getSigner()
      );
      try {
        await deployedLicenseContract.revokeLicense(license.id);

        const formData = new FormData();
        formData.append("servicer_address", auth.user.wallet_address);
        formData.append("owner", license.owner.toString());
        formData.append("license_id", license.id);
        axios
          .post(
            process.env.REACT_APP_BACKEND_URL + "/revoke_license",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response: AxiosResponse) => {
            fetchRevokedLicenses();
            alert(
                `License Contract ${license.address} with ID: ${license.id} Succesfully revoked!`
              );
          });
      } catch (e) {
        alert(e.reason);
      }
    }
  };

  return (
    <>
      <NavBar theme={theme} themeToggler={toggleTheme} />
      <RevokeLicensesPageContainer>
        <h1 style={{ marginTop: "5%" }}>Revoke Licenses</h1>
        {pendingRevokalLicenses ? (
          <Table
            columns={columns}
            data={pendingRevokalLicenses}
            onApproveClick={onApproveClick}
          />
        ) : (
          <p>No Licenses are pending revokal</p>
        )}
      </RevokeLicensesPageContainer>
    </>
  );
};

export default RevokeLicensePage;
